import { LayoutDashboard, Building2, Receipt, Tags, Users, Sparkles, ScrollText, Settings, LucideIcon, LayoutTemplate, DollarSign, Factory, KeyRound, Blocks, ArrowLeftRight, HeartPulse, Activity } from 'lucide-react';

export interface NavItem { label: string; to: string; icon: LucideIcon; activePrefix?: string; }
export interface NavGroup { group: string; items: NavItem[]; }

export const NAV: NavGroup[] = [
  { group: 'Overview',  items: [{ label: 'Overview',     to: '/dashboard',     icon: LayoutDashboard }] },
  { group: 'Customers', items: [
    { label: 'Companies',     to: '/companies',     icon: Building2 },
    { label: 'Subscriptions', to: '/subscriptions', icon: Receipt },
    { label: 'Plans',         to: '/plans',         icon: Tags },
    { label: 'Pricing',       to: '/pricing',       icon: DollarSign },
    { label: 'Users',         to: '/users',         icon: Users },
  ]},
  { group: 'Catalog', items: [
    { label: 'Default Templates', to: '/default-templates', icon: LayoutTemplate },
    { label: 'Industry Blueprints', to: '/blueprints',      icon: Blocks },
    { label: 'Industry Configs',  to: '/industry-configs',  icon: Factory },
  ]},
  { group: 'Platform',  items: [
    { label: 'AI Control Center', to: '/ai/usage', activePrefix: '/ai/', icon: Sparkles },
    { label: 'Platform Integrations', to: '/integrations', icon: KeyRound },
    { label: 'WhatsApp Health', to: '/whatsapp-health', icon: HeartPulse },
    { label: 'System Health', to: '/system-health', icon: Activity },
    { label: 'Exchange rates', to: '/exchange-rates', icon: ArrowLeftRight },
    { label: 'Audit Logs',   to: '/audit-log',    icon: ScrollText },
  ]},
  { group: 'Account',   items: [{ label: 'Security & Settings', to: '/settings', icon: Settings }] },
];
